import { Controller } from "@hotwired/stimulus"

// Presets are per domain, so a domain change reloads the amount field.
// The reload clears the chosen amount instead of converting it.
export default class extends Controller {
  static targets = ["frame"]
  static values = { url: String }

  reload(event) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("domain_id", event.target.value)
    this.frameTarget.src = url.toString()
  }
}
